var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AddDialog from './AddDialog';
import CategoryService from '../../../api/CategoryService';
import { Loading } from 'element-ui';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { mapGetters } from 'vuex';
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        return _this;
    }
    BillHeader.prototype.created = function () {
        this.service = CategoryService.getInstance();
    };
    BillHeader.prototype.add = function () {
        var _this = this;
        var instance = this.$dialog(AddDialog, {}, {
            title: "添加类别",
            width: 600,
            height: 390
        }).instance;
        instance.$on("freshCategory", function () {
            _this.$emit('search');
            _this.$emit('fresh-tree');
        });
    };
    BillHeader.prototype.importData = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    BillHeader.prototype.exportData = function () {
        if (!this.selectRows.length) {
            this.$message.error("请选择货品分类");
            return;
        }
        ;
        var orderIds = this.selectRows.map(function (item) { return item.goods_type_id; });
        var url = "supplierclientapi/suppliergoodstype/export?ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, "token", this.user.token);
        location.href = url;
    };
    BillHeader.prototype.changeCategory = function (status) {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error('请选择分类');
            return;
        }
        this.$confirm("\u786E\u5B9A\u8981" + (status === 0 ? '删除' : '恢复') + "\u9009\u4E2D\u7684\u5206\u7C7B\uFF1F", '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.change({
                    goods_type_ids: _this.getCategoryId(),
                    goods_type_status: status
                }).then(function (res) {
                    loadingInstance_1.close();
                    _this.$message.success(res.data.msg);
                    _this.$emit('search');
                    _this.$emit('fresh-tree');
                }, function (err) {
                    _this.$message.error(err.message || err.msg);
                    loadingInstance_1.close();
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message);
                });
            }
        }).catch(function () { });
    };
    BillHeader.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    BillHeader.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "supplierclientapi/suppliergoodstype/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.$emit('search');
            this.$emit('fresh-tree');
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    BillHeader.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    BillHeader.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    BillHeader.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    BillHeader.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    BillHeader.prototype.getCategoryId = function () {
        return this.selectRows.map(function (item) { return item.goods_type_id; }).join(',');
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], BillHeader.prototype, "selectRows", void 0);
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
